import React from 'react';
import clsx from 'clsx';
import styles from './TextInput.module.scss';

export interface TextInputProps {
  label: string;
  name: string;
  value: string;
  error?: string;
  maxLength?: number;
  type?: 'text' | 'number';
  rightElement?: React.ReactNode;
  // Rendered under the field - for messages that outlive a single validation error.
  children?: React.ReactNode;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onBlur: React.FocusEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
}

const TextInput: React.FC<TextInputProps> = ({
  label,
  name,
  value,
  error,
  maxLength,
  type = 'text',
  rightElement,
  children,
  onChange,
  onBlur,
  onKeyDown,
}) => (
  <div className={styles.wrapper}>
    <div className={clsx(styles.field, error && styles.hasError)}>
      {error && <span className={styles.floatingLabel}>{error}</span>}
      <input
        id={name}
        name={name}
        value={value}
        placeholder={label}
        aria-label={label}
        onChange={onChange}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        maxLength={maxLength}
        type="text"
        inputMode={type === 'number' ? 'numeric' : undefined}
        pattern={type === 'number' ? '[0-9]*' : undefined}
        className={styles.input}
      />
      <span className={styles.rightSlot}>
        {error && <span className={styles.errorIcon}>!</span>}
        {rightElement}
      </span>
    </div>
    {children}
  </div>
);

export default TextInput;
